import { lazy } from 'react';

import Loadable from 'components/Loadable';
import AuthLayout from 'layout/Auth';
import { PublicOnlyRoute } from 'components/auth/AuthGuards';
import RouteErrorBoundary from 'routes/RouteErrorBoundary';

const Login = Loadable(lazy(() => import('pages/auth/Login')));
const Register = Loadable(lazy(() => import('pages/auth/Register')));
const PrivacyPolicyAuthPage = Loadable(lazy(() => import('pages/legal/PrivacyPolicyAuthPage')));

const AuthRoutes = {
  path: '/',
  element: (
    <PublicOnlyRoute>
      <AuthLayout />
    </PublicOnlyRoute>
  ),
  errorElement: <RouteErrorBoundary />,
  children: [
    {
      path: 'login',
      element: <Login />
    },
    {
      path: 'register',
      element: <Register />
    },
    {
      path: 'privacy-policy',
      element: <PrivacyPolicyAuthPage />
    }
  ]
};

export default AuthRoutes;
